import { Route } from 'react-router-dom'

// Layout
import BusinessEmployeeLayout from '../layout/BusinessEmployeeLayout'

// Pages
import BusinessDashboardPage from '../pages/business/BusinessDashboardPage'
import SettingsPage from '../pages/business/SettingsPage'

// Guards
import ProtectedRoute from '../core/guards/ProtectedRoute'
import { AppRoute } from '../core/config/app-routes'
import MenuManagementPage from '@/pages/business/MenuManagementPage'

export default function BusinessEmployeeRoutes() {
  return (
    <>
      <Route
        path={AppRoute.BUSINESS_EMPLOYEE_DASHBOARD_ROUTE}
        element={
          <ProtectedRoute>
            <BusinessEmployeeLayout>
              <BusinessDashboardPage />
            </BusinessEmployeeLayout>
          </ProtectedRoute>
        }
      />

      {/* Menu Management */}
      <Route
        path={AppRoute.BUSINESS_EMPLOYEE_MENU_ROUTE}
        element={
          <ProtectedRoute>
            <BusinessEmployeeLayout>
              <MenuManagementPage />
            </BusinessEmployeeLayout>
          </ProtectedRoute>
        }
      />

      {/* Settings */}
      <Route
        path={AppRoute.BUSINESS_EMPLOYEE_SETTINGS_ROUTE}
        element={
          <ProtectedRoute>
            <BusinessEmployeeLayout>
              <SettingsPage />
            </BusinessEmployeeLayout>
          </ProtectedRoute>
        }
      />
    </>
  )
}

